import React, { memo } from 'react';

import { Card } from '@/components';
import { TabType } from '@/components/Types';
import { ViewTDAResponse } from '@/types/tda';
import { formatearNumero } from '@/utils';

type Props = {
  tab: TabType;
  tourney: ViewTDAResponse | null;
};

export const CardPosition: React.FC<Props> = memo(({ tab, tourney }) => {
  return (
    <Card className="flex justify-between lg:justify-normal px-2 h-11 w-full py-0 items-center bg-white mt-2 lg:pl-10 lg:mt-5">
      <p className="text-gdt-gray-3 font-semibold text-xs lg:text-sm">
        TU POSICIÓN EN {tab === TabType.FirstTab ? 'LA FECHA' : 'EL TORNEO'}
      </p>
      <strong className="text-gdt-blue text-xl lg:text-3xl lg:ml-4">
        {tab === TabType.FirstTab
          ? tourney?.posicion_fecha && tourney?.posicion_fecha !== '-'
            ? `#${formatearNumero(Number(tourney?.posicion_fecha))}`
            : '-'
          : tourney?.posicion && tourney?.posicion !== '-'
          ? `#${formatearNumero(Number(tourney?.posicion))}`
          : '-'}
      </strong>
    </Card>
  );
});

CardPosition.displayName = 'CardPosition';
